import { all, put, takeEvery } from "@redux-saga/core/effects";
import { errorHandler, isAbdmSessionError } from "../../services/error";
import { removeStatus } from "./actions";
import { logoutHealthId } from "../patients/actions";
import { logout } from "../authentication/actions";
import * as Sentry from "@sentry/react";

export const statusActionTypes = {
  SET_ERROR_STATUS: "SET_ERROR_STATUS",
  SET_SUCCESS_STATUS: "SET_SUCCESS_STATUS",
  CLEAR_STATUS: "CLEAR_STATUS"
};

function* setErrorStatusWorker(action) {
  try {
    Sentry.captureException(action.payload.message, {
      tags: { userType: "patient" },
      extra: { fatal: false, code: action.payload.code }
    });
    const error = errorHandler(action.payload);
    console.warn(error.message, "error.message");

    yield put({
      type: "SET_STATUS",
      payload: {
        code: error.code,
        message: error.message
      }
    });
    setTimeout(() => {
      removeStatus();
    }, 4000);

    if (isAbdmSessionError(error.message)) {
      logoutHealthId();
    }

    if (error.code === "auth" || action.payload.code === "permission-denied") {
      yield put({
        type: "RESET"
      });
      logout(true);
    }
  } catch (error) {
    console.error(error);
  }
}

function* setSuccessStatusWorker(action) {
  try {
    yield put({
      type: "SET_STATUS",
      payload: {
        code: null,
        message: action.payload.message
      }
    });
    setTimeout(() => {
      removeStatus();
    }, 4000);
  } catch (error) {}
}

function* setStatusResponseWorker() {
  yield put({
    type: "REMOVE_STATUS"
  });
}

export default function* statusWatcher() {
  yield all([
    takeEvery("SET_ERROR_STATUS", setErrorStatusWorker),
    takeEvery("SET_SUCCESS_STATUS", setSuccessStatusWorker),
    takeEvery("CLEAR_STATUS", setStatusResponseWorker)
  ]);
}
